import { createAction } from '@reduxjs/toolkit'
import { call, put, takeEvery } from 'redux-saga/effects'

import { createFlagComment } from '../../../api/projects-api'
import { FlagComments } from '../../../models/flags'
import { updateFlagComments } from '../../slices/materialFlags'

export const createFlagCommentAction = createAction<{ flagID: number; comment: string; createdByUserEmail: string }>(
    'createFlagCommentAction'
)

export function* handleCreateFlagComment({ payload }: ReturnType<typeof createFlagCommentAction>) {
    const { flagID, comment, createdByUserEmail } = payload

    const response: FlagComments = yield call(createFlagComment, {
        flagID,
        comment,
        createdByUserEmail,
    })

    yield put(
        updateFlagComments({
            flagID,
            comment: response,
        })
    )
}

export function* watchForCreateFlagCommentAction() {
    yield takeEvery(createFlagCommentAction.type, handleCreateFlagComment)
}
